import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubjectManagmentService } from 'src/app/Services/subject-management/subject-management.service';
import { UserAuthDetails } from 'src/app/Services/user-sessions/user-auth-details';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-content-management-clone-subject-selector',
  templateUrl: './content-management-clone-subject-selector.component.html',
  styleUrls: ['./content-management-clone-subject-selector.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ContentManagementCloneSubjectSelectorComponent implements OnInit {
  @Input() route: string = '';
  @Input() param: string = '';
  @Input() toCourseId: any = null;
  @Input() initialSelection: any = null;

  cloneForm: FormGroup;
  examAgencies: any[] = [];
  courses: any[] = [];
  years: any[] = [];
  subjects: any[] = [];
  selectedSubject: any = null;

  loggedInUser: any;
  selectbutton = true;
  showAlert = false;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private subjectService: SubjectManagmentService,
    private readonly toaster: ToastrService
  ) {
    this.retrieveLoggedInUserId();
  }

  ngOnInit(): void {
    this.cloneForm = this.fb.group({
      examAgency: [''],
      course: [''],
      year: [''],
      subject: [''],
    });
    this.getExamAgencies();
  }

  getExamAgencies() {
    const data = {
      category: 'EXAM_AGENCY@CONTENT',
    };
    this.subjectService.getCodes(data).subscribe({
      next: (res) => {
        this.examAgencies = [...res];
        this.prefillFromSelection();
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  prefillFromSelection() {
    if (!this.initialSelection) {
      return;
    }

    const examAgencyCode = this.initialSelection?.examAgencyId || this.initialSelection?.examAgency?.Code;
    const courseCode = this.initialSelection?.courseId || this.initialSelection?.courseCode;
    const yearCode = this.initialSelection?.yearCode || this.initialSelection?.year?.Code;

    if (!examAgencyCode) {
      return;
    }

    this.cloneForm.patchValue({
      examAgency: examAgencyCode,
      course: '',
      year: '',
      subject: '',
    });

    this.subjectService.getCodes({ category: `EXAM_COURSE@${examAgencyCode}` }).subscribe({
      next: (courseRes: any[]) => {
        this.courses = [...courseRes];

        if (!courseCode) {
          return;
        }

        this.cloneForm.patchValue({ course: courseCode });

        this.subjectService.getCodes({ category: `COURSE_YEAR@${courseCode}` }).subscribe({
          next: (yearRes: any[]) => {
            this.years = [...yearRes];

            if (!yearCode) {
              return;
            }

            this.cloneForm.patchValue({ year: yearCode });

            this.subjectService.getCodes({ category: `COURSE_SUBJECT@${yearCode}` }).subscribe({
              next: (subjectRes: any[]) => {
                this.subjects = [...subjectRes];
                this.cloneForm.patchValue({ subject: '' });
                this.selectedSubject = null;
                this.selectbutton = true;
              },
              error: (error) => {
                console.log(error);
              },
            });
          },
          error: (err) => {
            console.log(err);
          },
        });
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getCourses(event: Event) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    const data = {
      category: `EXAM_COURSE@${selectedValue}`,
    };
    this.selectbutton = true;
    this.cloneForm.get('course')?.reset();
    this.cloneForm.get('year')?.reset();
    this.cloneForm.get('subject')?.reset();
    this.showAlert = false;
    this.courses = [];
    this.years = [];
    this.subjects = [];
    this.subjectService.getCodes(data).subscribe({
      next: (res) => {
        this.courses = [...res];
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getYears(event: Event) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    const data = {
      category: `COURSE_YEAR@${selectedValue}`,
    };
    this.selectbutton = true;
    this.cloneForm.get('year')?.reset();
    this.cloneForm.get('subject')?.reset();
    this.years = [];
    this.subjects = [];
    this.showAlert = false;
    this.subjectService.getCodes(data).subscribe({
      next: (res) => {
        this.years = [...res];
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getCourseSubjects(event: Event) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    const data = {
      category: `COURSE_SUBJECT@${selectedValue}`,
    };
    this.cloneForm.get('subject')?.reset();
    this.subjects = [];
    this.showAlert = false;

    this.subjectService.getCodes(data).subscribe({
      next: (res: any) => {
        this.subjects = [...res];
        if (this.subjects.length > 0) {
          this.selectbutton = true;
        } else {
          this.showAlert = true;
          this.selectbutton = true;
        }
      },
      error: (error) => {
        console.log(error);
        this.showAlert = true;
      },
    });
  }

  onSubjectChange(event: Event) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    if (!selectedValue) {
      this.selectbutton = true;
      this.selectedSubject = null;
      return;
    }

    // Just select the subject and enable the button
    const selectedSubject = this.subjects.find((s) => s.Code === selectedValue);
    if (selectedSubject) {
      this.selectedSubject = selectedSubject;
      this.selectbutton = false;
    } else {
      this.selectbutton = true;
      this.selectedSubject = null;
    }
  }

  selectAndClose() {
    const examAgency = this.examAgencies.find(
      (e) => e.Code === this.cloneForm.get('examAgency')?.value
    );

    const course = this.courses.find(
      (c) => c.Code === this.cloneForm.get('course')?.value
    );

    const year = this.years.find(
      (y) => y.Code === this.cloneForm.get('year')?.value
    );

    if (!examAgency || !course || !year || !this.selectedSubject) {
      this.toaster.error('Please select Exam Agency, Course, Exam Year and Subject.', 'Error');
      return;
    }

    this.activeModal.close({
      subject: this.selectedSubject,
      examAgency: examAgency,
      course: course,
      year: year,
      subjectId: this.selectedSubject?.Code,
      subjectCode: this.selectedSubject?.Code,
      subjectName: this.selectedSubject?.Name,
      courseId: course?.Code,
      examAgencyId: examAgency?.Code,
      courseCode: course?.Code,
      yearCode: year?.Code,
      toCourseId: this.toCourseId,
    });
  }

  cancel() {
    this.activeModal.dismiss('Cancel clicked');
  }

  retrieveLoggedInUserId() {
    const loggedInUserId = UserAuthDetails.getUserLoggedInId();

    if (!loggedInUserId) {
      this.toaster.error('Please Provide Logged in User Id', 'Error');
      return;
    }

    this.loggedInUser = loggedInUserId;
  }
}
